export default function toMatrix(transformation) {
    if (transformation && typeof transformation.matrix === "function") {
        return transformation.matrix();
    }

    return transformation;
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/geometry/to-matrix.js